import { useMemo } from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  currentDeployment as currentDeploymentSelector,
  ResourceCollectionType
} from "Reducers/environment/deployment";

export const useGetResourceType = () => {
  const { appName } = useDecodedParams<{
    appName: string;
  }>();
  const currentDeployment = useSelectorWithUrlParams(currentDeploymentSelector);

  const resourceType = useMemo(() => {
    let type = "";
    const { webapps, services, workers } = currentDeployment ?? {
      webapps: {},
      services: {},
      workers: {}
    };
    Object.entries({ webapps, services, workers }).forEach(
      ([label, resource]) => {
        Object.keys(resource ?? {}).forEach(resourceLabel => {
          if (appName === resourceLabel) {
            type = label;
          }
        });
      }
    );
    return type as ResourceCollectionType;
  }, [currentDeployment, appName]);

  return resourceType;
};
